/* eslint-disable import/prefer-default-export */
export const APP_DESCRIPTION = 'SOTU is a Slack tool that gives a snapshot of every project in your company -- without all the digging.'; // eslint-disable-line max-len



/** WEBPACK FOOTER **
 ** ./src/config/shared.js
 **/